import { AnimatePageModel } from '@desygner/api-animations-models';

export function getBBox(element: Element): DOMRect | undefined {
  if ('getBBox' in element) {
    return (element as any).getBBox();
  }

  return undefined;
}
export function createGroupContainer(targets: SVGSVGElement[] | Element[]): SVGElement | undefined {
  if (!targets?.length) return;

  const groupContainer: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');

  groupContainer.setAttribute('class', 'group element');

  let isContainerInserted = false;

  for (let i = 0; i < targets.length; i++) {
    const target = targets[i];

    if (!target?.parentElement) continue;

    if (!isContainerInserted) {
      target.insertAdjacentElement('afterend', groupContainer);
      groupContainer.setAttribute('data-id', target.id);
      isContainerInserted = true;
    }

    groupContainer.appendChild(target);
  }

  return groupContainer;
}

export function createTargetGroup(): SVGElement {
  const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');

  group.classList.add('animated-group', 'element');

  return group;
}

export function ungroupElements(svg: SVGSVGElement): SVGSVGElement {
  if (!svg) return svg;

  let target = svg.querySelector('g.element.group');

  while (target) {
    const parent = target.parentNode;
    const anchor = target.nextSibling;
    const children = new Array(target.childNodes.length);

    let i = 0;

    while (target.firstChild && parent) {
      let child = target.firstChild;

      children[i++] = child = parent.insertBefore(child, anchor);
    }

    if (parent) {
      parent.removeChild(target);
    }

    children.forEach((child) => child.classList.add('element'));
    target = svg.querySelector('g.element.group');
  }

  return svg;
}

export function groupElements(animate: AnimatePageModel, svg: SVGSVGElement): SVGSVGElement {
  if (!animate?.groupAnimations?.length) return svg;

  animate.groupAnimations.forEach((group) => {
    const elements = group.elements;
    const targets = [
      ...svg.querySelectorAll(elements.map((stringId) => '#' + stringId).join(', ')),
    ];

    createGroupContainer(targets);
  });

  return svg;
}

export function prepareGroupAnimations(
  svgElement: SVGSVGElement,
  animate: AnimatePageModel
): SVGSVGElement {
  const groupAnimations = animate.groupAnimations ?? [];
  const svgGroups = [...svgElement.querySelectorAll('.main > .element.group')];

  groupAnimations.forEach((group) => {
    /*
     * Create a new group element for each group
     * The group element is inserted after the first element in the group to maintain layer order
     * The elements are selected using querySelectorAll on the same selector to maintain layer order within the group
     * The logic needs to match API logic
     */
    const selector = group.elements.map((element) => `#${element}`).join(', ');
    const target = [...svgElement.querySelectorAll(selector)];
    const groupElement = createTargetGroup();

    /*
     * The group element is inserted after the first element in the group
     * The layer order of the group is determined by the first element in the group
     */

    const candidate =
      target[0] && svgGroups.find((group) => group.querySelector(`#${target[0].id}`));

    groupElement.setAttribute('data-id', target[0].id);
    (candidate ?? target[0]).insertAdjacentElement('afterend', groupElement);

    const addedItem: Element[] = [];

    for (const item of target) {
      if (addedItem.includes(item)) continue;

      let isGroupAdded = false;

      for (const svgGroup of svgGroups) {
        if (svgGroup.querySelector(`#${item.id}`)) {
          groupElement.appendChild(svgGroup);
          addedItem.push(...target.filter((element) => svgGroup.querySelector(`#${element.id}`)));

          isGroupAdded = true;
          break;
        }
      }

      if (!isGroupAdded) {
        groupElement.appendChild(item);
        addedItem.push(item);
      }
    }
  });

  if (groupAnimations.length > 0) {
    svgElement.querySelectorAll('.main > .element.group').forEach((group) => group.remove());
  }

  return svgElement;
}

export function isAnimationValid(animate: AnimatePageModel) {
  return (animate.animation && animate.animation !== 'no_animation') || !!animate.elementAnimations;
}
